<template lang="pug">
  v-menu(bottom right v-if="myFeatures.eligibleFeatures.includes('REPORT')")
    template(v-slot:activator='{ on }')
      v-icon(v-on='on' @click='vibrate()' medium) mdi-dots-vertical
    v-list.pa-0
      v-list-item.pa-2(@click='vibrate();gotoCounterOrders()')
        v-icon.pr-1(small) mdi-format-list-numbered
        v-list-item-title.pa-0 {{counter.code}} Orders
      v-list-item.pa-2(@click='vibrate();gotoCounterInventory()')
        v-icon.pr-1(small) mdi-format-list-bulleted
        v-list-item-title.pa-0 {{counter.code}} Inventory
      v-list-item.pa-2(@click='vibrate();gotoCounterReports()')
        v-icon.pr-1(small) mdi-library-books
        v-list-item-title.pa-0 {{counter.code}} Report
</template>

<script>
import { storeMixin } from "../../mixins/storeMixin";
export default {
  name: "counter-navigator",
  mixins: [storeMixin],
  props: {
    counter: Object
  },
  methods: {
    gotoCounterOrders() {
      this.selectCounter(this.counter);
      this.$router.push({
        name: "counterOrders",
        params: {
          restaurantId: this.counter._restaurantKey,
          counterId: this.counter.id
        }
      });
    },
    gotoCounterInventory() {
      this.selectCounter(this.counter);
      this.$router.push({
        name: "counterInventory",
        params: {
          restaurantId: this.counter._restaurantKey,
          counterId: this.counter.id
        }
      });
    },
    gotoCounterReports() {
      this.selectCounter(this.counter);
      this.$router.push({
        name: "counterReports",
        params: {
          restaurantId: this.counter._restaurantKey,
          counterId: this.counter.id
          //reportId: this.counterReport.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>